import { DestroyRef, Directive, ElementRef, inject, input } from '@angular/core';
import { GUIDED_TOUR_REGISTRY, type GuidedTourAnchorRef } from './guided-tour.model';

/** Marks an element a step of the nearest `nr-guided-tour` can frame. */
@Directive({
  selector: '[nrTourAnchor]',
})
export class GuidedTourAnchorDirective implements GuidedTourAnchorRef {
  private readonly registry = inject(GUIDED_TOUR_REGISTRY, { optional: true });

  readonly nrTourAnchor = input.required<string>();

  readonly element = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;

  readonly name = this.nrTourAnchor;

  constructor() {
    const { registry } = this;
    if (!registry) return;
    registry.register(this);
    inject(DestroyRef).onDestroy(() => {
      registry.unregister(this);
    });
  }
}
